import * as React from 'react';
import { Button } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { FilterOutlined, PlusOutlined } from '@ant-design/icons';

import { FormFieldIds } from 'common/helpers/utils';
import { AutocompleteSelect } from 'features/pagination/components/AutocompleteSelect';
import { AutocompleteField, Filters } from 'features/pagination/models/paginationModel';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { PaginationRequestAction } from 'features/pagination/actions/paginationActions';
import { Antd3FormProps, WrappedFormUtils } from 'common/components/deprecated/antd3';
import { CreatePaths } from 'features/create/models/createModel';
import { TableFiltersBar } from 'common/components/TableFiltersBar';
import { FilterDrawerContracts } from 'common/components/FilterDrawerContracts';
import { GoldButton } from 'common/components/GoldButton';

import { EditPaths } from '../models/editModel';

type FormProps = {
    searchByContractTitle(contractTitle: string): PaginationRequestAction;
    onRemoveContractTitleAutocomplete(): PaginationRequestAction;
    clearFilters(): void;
    refreshTable?(): void;
    form: WrappedFormUtils;
    filter?: PaginationFilters;
};

type Props = FormProps & Antd3FormProps;

export const EditContractsTableFiltersBar: React.FunctionComponent<Props> = ({
    searchByContractTitle,
    onRemoveContractTitleAutocomplete,
    clearFilters,
    refreshTable,
    form,
    filter,
}) => {
    const { pathname } = useLocation();
    const isMyView = pathname.includes(EditPaths.MyContracts);
    const { title, ...filterSearchParams } = (filter && filter.values) || {};

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = React.useState(false);

    return (
        <>
            <TableFiltersBar
                leftButtons={[
                    <Link to={isMyView ? EditPaths.Contracts : EditPaths.MyContracts}>
                        <Button type="primary">{isMyView ? 'All Projects' : 'My Projects'}</Button>
                    </Link>,
                    <Link to={CreatePaths.Contract}>
                        <GoldButton icon={<PlusOutlined />}>New Project</GoldButton>
                    </Link>,
                ]}
                filters={[
                    <AutocompleteSelect
                        id={FormFieldIds.Title}
                        placeholder="Search by Projects"
                        form={form}
                        autocompleteField={
                            isMyView ? AutocompleteField.MyContract : AutocompleteField.Contract
                        }
                        onSelect={searchByContractTitle}
                        onRemove={onRemoveContractTitleAutocomplete}
                        notFoundContent="No projects found"
                        requiredMessage="Project is required"
                        showLabel={false}
                        defaultValue={filter && filter.values.title}
                        searchParams={filterSearchParams as Filters}
                    />,
                ]}
                filtersButtons={[
                    <Button
                        type="primary"
                        icon={<FilterOutlined />}
                        onClick={() => setIsFilterDrawerOpen(true)}
                    >
                        All Filters
                    </Button>,
                    <Button onClick={clearFilters}>Clear Filters</Button>,
                ]}
            />
            <FilterDrawerContracts
                visible={isFilterDrawerOpen}
                onClose={() => setIsFilterDrawerOpen(false)}
                onApply={refreshTable}
            />
        </>
    );
};
